import React from 'react'
import { observer } from 'mobx-react'
import { Checkbox as BaseCheckbox} from "@morningtrain/react-columns";
import useModel from '@morningtrain/react-resources/dist/es/hooks/use-model';
import {string} from "prop-types";

function ListCheckbox (props) {
  let temp = useModel();
  let indexes = props.indexProperty.split('.');
  for (let indexKey of indexes) {
    temp = (temp.name && temp.name.includes('ObservableMap')) ? temp.get(indexKey) : temp[indexKey];
    if (!temp || temp === 'undefined') {
      return <BaseCheckbox {...props} />
    }
  }
  let name = props.name + '[' + temp + ']';
  const newProps = {...props, name: name};
  return <BaseCheckbox {...newProps} />
}

ListCheckbox.defaultProps = {
  ...BaseCheckbox.defaultProps,
  indexProperty: 'id'
}

ListCheckbox.propTypes = {
  indexProperty: string
}

//supplier.id

export default observer(ListCheckbox)
